// if(!customElements.get('product-model')){customElements.define('product-model',class ProductModel extends DeferredMedia{constructor(){super()}
// loadContent(){super.loadContent();Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:this.setupModelViewerUI.bind(this),},])}
// setupModelViewerUI(errors){if(errors)return;this.modelViewerUI=new Shopify.ModelViewerUI(this.querySelector('model-viewer'))}})}
// window.ProductModel={loadShopifyXR(){Shopify.loadFeatures([{name:'shopify-xr',version:'1.0',onLoad:this.setupShopifyXR.bind(this),},])},setupShopifyXR(errors){if(errors)return;if(!window.ShopifyXR){document.addEventListener('shopify_xr_initialized',()=>this.setupShopifyXR());return}
// document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON)=>{window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));modelJSON.remove()});window.ShopifyXR.setupXRElements()},};window.addEventListener('DOMContentLoaded',()=>{if(window.ProductModel)window.ProductModel.loadShopifyXR();})

    if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    loadContent() {
      super.loadContent();
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      const modelViewer = this.querySelector('model-viewer');
      if (!modelViewer) return;

      /* ===============================
         ONLY LEFT-RIGHT ROTATION
         TOP-BOTTOM MOVEMENT DISABLED
      ================================ */

      modelViewer.setAttribute('camera-controls', '');
      modelViewer.setAttribute('min-camera-orbit', 'auto 90deg auto');
      modelViewer.setAttribute('max-camera-orbit', 'auto 90deg auto');

      this.modelViewerUI = new Shopify.ModelViewerUI(modelViewer);
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });

    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
